module.exports = __webpack_public_path__ + "media/images/percentage-of-unsheltered-families-bb74ba950349387c2a264c9e95651c53.png";